export default function Obrigado() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white px-6 text-center">
      <h1 className="text-4xl font-bold text-green-600 mb-4">
        Assinatura confirmada!
      </h1>

      <p className="text-gray-700 text-lg max-w-xl mb-6">
        Obrigado por assinar o Gerador de Conteúdo com IA.
        Seu acesso será enviado ao seu e-mail em alguns minutos.
      </p>

      <a
        href="/"
        className="px-5 py-2.5 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700"
      >
        Voltar para o site
      </a>
    </div>
  );
}
